export default __webpack_public_path__ + "static/media/portrait_overlay.62d288aa.png";